/**
 * Release calendar days for Guardian Firsts "after release" elapsed.
 * Keys match Firsts card base names, story subtitles, or Pantheon encounter labels.
 */
export const ACTIVITY_RELEASE_DATES: Record<string, string> = {
  // --- D1 raids ---
  "Vault of Glass": "2014-09-16",
  "Crota's End": "2014-12-09",
  "King's Fall": "2015-09-18",
  "Wrath of the Machine": "2016-09-23",

  // --- D1 story expansions (story-first-missions subtitles) ---
  Destiny: "2014-09-09",
  "The Dark Below": "2014-12-09",
  "House of Wolves": "2015-05-19",
  "The Taken King": "2015-09-15",
  "Rise of Iron": "2016-09-20",

  // --- D2 raids ---
  Leviathan: "2017-09-13",
  "Eater of Worlds": "2017-12-05",
  "Spire of Stars": "2017-12-05",
  "Last Wish": "2018-09-14",
  "Scourge of the Past": "2018-12-07",
  "Crown of Sorrow": "2019-06-04",
  "Garden of Salvation": "2019-10-05",
  "Deep Stone Crypt": "2020-11-21",
  "Vault of Glass (D2)": "2021-05-22",
  "Vow of the Disciple": "2022-03-05",
  "King's Fall (D2)": "2022-08-26",
  "Root of Nightmares": "2023-03-10",
  "Crota's End (D2)": "2023-09-01",
  "Salvation's Edge": "2024-06-07",
  "The Desert Perpetual": "2025-07-19",
  "Desert Perpetual": "2025-07-19",
  // Epic difficulty launched after Standard
  "The Desert Perpetual: Epic": "2025-09-27",
  "Desert Perpetual: Epic": "2025-09-27",

  // --- D2 dungeons ---
  "The Shattered Throne": "2018-09-25",
  "Pit of Heresy": "2019-10-29",
  Prophecy: "2020-06-09",
  "Grasp of Avarice": "2021-12-07",
  Duality: "2022-05-27",
  "Spire of the Watcher": "2022-12-09",
  "Ghosts of the Deep": "2023-05-26",
  "Warlord's Ruin": "2023-12-01",
  "Vesper's Host": "2024-10-01",
  "Sundered Doctrine": "2025-02-07",
  Equilibrium: "2025-12-13",
  "Equilibrium: Contest": "2025-12-13",

  // --- D2 story expansions ---
  "Red War": "2017-09-06",
  "Red War (Base Game)": "2017-09-06",
  "Curse of Osiris": "2017-12-05",
  Warmind: "2018-05-08",
  Forsaken: "2018-09-04",
  Shadowkeep: "2019-10-01",
  "Beyond Light": "2020-11-10",
  "The Witch Queen": "2022-02-22",
  Lightfall: "2023-02-28",
  "The Final Shape": "2024-06-04",
  "The Edge of Fate": "2025-07-15",
  Renegades: "2025-12-02",

  // --- D2 seasons & episodes (story-first-missions subtitles) ---
  "Season of the Outlaw": "2018-09-04",
  "Season of the Outlaw (Forsaken)": "2018-09-04",
  "Season of the Forge": "2018-12-04",
  "Season of the Drifter": "2019-03-05",
  "Season of Opulence": "2019-06-04",
  "Season of the Undying": "2019-10-01",
  "Season of Dawn": "2019-12-10",
  "Season of the Worthy": "2020-03-10",
  "Season of Arrivals": "2020-06-09",
  "Season of the Hunt": "2020-11-10",
  "Season of the Chosen": "2021-02-09",
  "Season of the Splicer": "2021-05-11",
  "Season of the Lost": "2021-08-24",
  "Season of the Risen": "2022-02-22",
  "Season of the Haunted": "2022-05-24",
  "Season of Plunder": "2022-08-23",
  "Season of the Seraph": "2022-12-06",
  "Season of Defiance": "2023-02-28",
  "Season of the Deep": "2023-05-23",
  "Season of the Witch": "2023-08-22",
  "Season of the Wish": "2023-11-28",
  "Season of Reclamation": "2025-07-15",
  "Episode: Echoes": "2024-06-04",
  "Episode: Revenant": "2024-10-08",
  "Episode: Heresy": "2025-02-04",

  // --- Legacy Pantheon (Into the Light) ---
  "The Pantheon: Atraks Sovereign": "2024-04-30",
  "Atraks Sovereign": "2024-04-30",
  "The Pantheon: Oryx Exalted": "2024-05-07",
  "Oryx Exalted": "2024-05-07",
  "The Pantheon: Rhulk Indomitable": "2024-05-21",
  "Rhulk Indomitable": "2024-05-21",
  "The Pantheon: Nezarec Sublime": "2024-05-28",
  "Nezarec Sublime": "2024-05-28",

  // --- Monument of Triumph Pantheon ---
  "Pantheon: Calus Resplendent": "2026-06-09",
  "Calus Resplendent": "2026-06-09",
  "Pantheon: Morgeth Surpassing": "2026-06-16",
  "Morgeth Surpassing": "2026-06-16",
  "Pantheon: Insurrection Prime Revolutionary": "2026-06-23",
  "Insurrection Prime Revolutionary": "2026-06-23",

  // --- Rite of the Nine (event launch; not original dungeon release) ---
  "Rite of the Nine": "2025-05-06",
};
